import React, { useEffect } from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const Booking = () => {
  const [titleRef, titleVisible] = useScrollAnimation(0.1);
  const [widgetRef, widgetVisible] = useScrollAnimation(0.2);

  useEffect(() => {
    // Load Altegio/YCLIENTS widget script
    const script = document.createElement('script');
    script.src = 'https://w608855.alteg.io/widgetJS';
    script.charset = 'UTF-8';
    script.async = true;
    
    script.onload = () => {
      console.log('✓ Altegio widget script loaded');
      
      // Try to initialize widget if there's a global function
      if (window.AltegWidget) {
        window.AltegWidget.init();
      }
    };
    
    script.onerror = () => {
      console.error('✗ Altegio widget script failed to load');
    };
    
    document.head.appendChild(script);

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return (
    <section id="booking" className="py-32 bg-black">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div 
          ref={titleRef}
          className={`text-center mb-20 fade-in ${titleVisible ? 'visible' : ''}`}
        >
          <p className="text-white text-xs uppercase tracking-[0.3em] mb-4 font-montserrat font-medium">
            Foglalás
          </p>
          <h2 className="text-5xl md:text-6xl font-oswald font-bold text-white mb-6 uppercase tracking-tighter">
            Időpontfoglalás
          </h2>
          <p className="text-gray-400 text-base max-w-3xl mx-auto font-montserrat font-light">
            Foglalj időpontot egyszerűen online foglalási rendszerünkön keresztül.
          </p>
        </div>

        {/* Altegio Widget Container */}
        <div 
          ref={widgetRef}
          className={`slide-up ${widgetVisible ? 'visible' : ''}`}
        >
          <div className="bg-neutral-900 border border-neutral-800 rounded-sm overflow-hidden">
            {/* Altegio widget will inject here - try multiple possible IDs */}
            <div 
              id="yclients-widget" 
              className="min-h-[700px] w-full"
              data-url="https://n608855.alteg.io/"
            ></div>
          </div>
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-500 text-sm font-montserrat">
            Powered by Altegio
          </p>
        </div>
      </div>
    </section>
  );
};

export default Booking;
